import { useNavigate } from 'react-router';
import { ChevronLeft } from 'lucide-react';

export default function NFTGallery() {
  const navigate = useNavigate();

  return (
    <div className="h-screen overflow-hidden bg-gradient-to-b from-gray-900 to-black text-white" style={{ fontFamily: 'Outfit, sans-serif' }}>
      <div className="h-full overflow-y-auto">
        <div className="p-4">
          {/* Header */}
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center mb-8">
              {/* Back Button */}
              <button
                onClick={() => navigate(-1)}
                className="flex items-center gap-2 px-4 py-2 rounded-lg bg-gray-800 hover:bg-gray-700 transition-colors"
              >
                <ChevronLeft className="w-5 h-5" />
                <span>Back</span>
              </button>
            </div>

            {/* Coming Soon Message */}
            <div className="flex flex-col items-center justify-center py-20 space-y-6">
              <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-center">
                <span
                  style={{
                    fontFamily: 'Hyperspace Race Capsule, cursive',
                    background: 'linear-gradient(92deg, #FB8B00 -4.02%, #F6DF6F 24.3%, #FB8B00 50.55%, #F6DF6F 72.17%, #FB8B00 103.05%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text',
                  }}
                >
                  Coming Very Soon...{' '}
                </span>
                <span style={{ fontFamily: 'Hyperspace Race Capsule, cursive', color: '#FFFFFF' }}>👀</span>
              </h1>

              <div className="relative w-full max-w-2xl flex items-center justify-center mt-8">
                <img
                  src="/winner.svg"
                  alt="Trophy"
                  className="w-full h-auto object-contain"
                  style={{
                    filter: 'drop-shadow(0 0 20px rgba(254, 187, 1, 0.4))',
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
